import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { apiRequest } from "src/services/apiClient";
import ZaalaLogo from "src/components/ZaalaLogo/ZaalaLogo";
import { APP_INFO } from "src/config/appInfo";

type Status = "verifying" | "success" | "error";

export default function VerifyEmail() {
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const [status, setStatus] = useState<Status>("verifying");

    useEffect(() => {
        const token = params.get("token");
        if (!token) { setStatus("error"); return; }

        apiRequest(`/api/verify-email?token=${encodeURIComponent(token)}`, { method: "GET" })
            .then(() => setStatus("success"))
            .catch(() => setStatus("error"));
    }, []);

    return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#f8fafc" }}>
            <div style={{ background: "#fff", borderRadius: 16, padding: "40px 48px", boxShadow: "0 4px 24px rgba(0,0,0,0.08)", textAlign: "center", maxWidth: 420 }}>
                <div style={{ marginBottom: 20 }}>
                    <ZaalaLogo size={56} />
                    <div style={{ fontSize: 18, fontWeight: 700, color: "#1e293b", marginTop: 8 }}>{APP_INFO.appName}</div>
                </div>
                {status === "verifying" && (
                    <p style={{ color: "#6b7280" }}>{t("verifyEmail.verifying")}</p>
                )}
                {status === "success" && (
                    <>
                        <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
                        <h2 style={{ color: "#1e293b", marginBottom: 8 }}>{t("verifyEmail.successTitle")}</h2>
                        <p style={{ color: "#6b7280", marginBottom: 24 }}>{t("verifyEmail.successText")}</p>
                        <Link to="/login" style={{ background: "#4f46e5", color: "#fff", padding: "10px 28px", borderRadius: 8, textDecoration: "none", fontWeight: 600 }}>
                            {t("login.signIn")}
                        </Link>
                    </>
                )}
                {status === "error" && (
                    <>
                        <div style={{ fontSize: 40, marginBottom: 12 }}>❌</div>
                        <h2 style={{ color: "#1e293b", marginBottom: 8 }}>{t("verifyEmail.errorTitle")}</h2>
                        <p style={{ color: "#6b7280" }}>{t("verifyEmail.errorText")}</p>
                    </>
                )}
            </div>
        </div>
    );
}
